import { x } from '@xstyled/styled-components';
import React, { ComponentProps, useEffect, useState } from 'react';
import ArrowIcon from '~/assets/icons/arrow.svg';
import { styled } from '@xstyled/styled-components';
import { useEditorStore } from '~/shell/Store';
import useIsDarkMode from '~/lib/themes/hooks/useIsDarkMode';

const ArrowIconStyled = styled(ArrowIcon)`
  path {
    fill: ${({ fill }) => fill};
  }
`;

const Button = styled(x.button)`
  &:focus-visible {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
    z-index: 201;
  }

  &:focus-visible::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 50%;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
`;

export const IconButton = (props: ComponentProps<typeof x.button>) => {
  const { editorMode } = useEditorStore();
  const isDarkMode = useIsDarkMode();
  const [isDark, setIsDark] = useState(editorMode ? false : isDarkMode);

  useEffect(() => {
    if (editorMode) {
      return;
    }

    setIsDark(isDarkMode);
  }, [isDarkMode, editorMode]);

  return (
    <Button
      w="51px"
      h="51px"
      bg={isDark ? 'rgba(255,255,255,0.2)' : 'rgba(241, 241, 241,0.5)'}
      borderRadius="50%"
      zIndex={200}
      display="flex"
      alignItems="center"
      justifyContent="center"
      alignSelf="center"
      justifySelf="center"
      transition="all 0.3s ease-out"
      cursor={{ disabled: 'not-allowed' }}
      border={
        isDark
          ? '2px solid rgba(255, 255, 255, 0.5)'
          : '2px solid rgba(0, 0, 0, 0.5)'
      }
      opacity={{ disabled: '0.7' }}
      position="relative"
      {...props}
    >
      <ArrowIconStyled
        aria-hidden="true"
        focusable="false"
        fill={isDark ? '#FFF' : '#000'}
      />
    </Button>
  );
};
